import { Col, Form, Input, Row } from 'antd';
import { useIntl } from 'react-intl';
import { ListCustomersQuery } from '@/core/domain/people/Customers/Customers.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import AppPageHeader from '@/components/_common/AppPageHeader';
import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';

const CustomersFiltersTableModal: React.FC<
  ExtraFiltersProps<ListCustomersQuery>
> = ({ setQueryParams }) => {
  const intl = useIntl();

  return (
    <AppPageHeader
      onSearch={(value) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      extraFilters={
        <Form>
          <Row gutter={8}>
            <Col span={12}>
              <Input
                name="cpfCnpj"
                onChange={({ target: { value } }) =>
                  setQueryParams((prev) => ({ ...prev, cpfCnpj: value }))
                }
                placeholder={intl.formatMessage({
                  id: 'customers.filters.cpfCnpj',
                })}
              />
            </Col>

            <Col span={12}>
              <OrderExtraFilter
                onChange={(value) =>
                  setQueryParams((prev) => ({
                    ...prev,
                    order: value,
                  }))
                }
              />
            </Col>
          </Row>
        </Form>
      }
    />
  );
};

export default CustomersFiltersTableModal;
